import { debounceSearch, recordAndTrackSearch, debounceRecordAndTrackSearch } from '../utils/searchUtils';
import { useCallback } from 'react';
// @ts-expect-error Untyped import
import { SEARCH } from '../constants/reportFilters';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
// @ts-expect-error Untyped import
import { selectFilters } from '../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { setReportsFilters } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { getAiSearchResults } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { clearReportTemplates } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { getChirpAiSearchResults } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { getReportTemplateSearchResults } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { selectGenerativeAIEnabled } from '../selectors/aiSettingsSelector';
import { getIsUngatedToUseChirpEndpoints } from '../selectors/gatesSelector';
import { selectReportCollectionTemplatesByKey } from '../redux/reportCollectionTemplates';
const useUpdateSearch = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters).toJS();
  const {
    reportId
  } = useParams();
  const isGenerativeAiEnabled = useSelector(selectGenerativeAIEnabled);
  const templatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  const isUngatedToUseChirpEndpoints = useSelector(getIsUngatedToUseChirpEndpoints);
  const updateSearch = useCallback(input => {
    if (reportId) {
      history.push('/');
    }
    const shouldFetchTemplates = input && input.length > 0;
    dispatch(clearReportTemplates());
    dispatch(setReportsFilters(Object.assign({}, filters, {
      [SEARCH]: input,
      offset: 0
    })));
    if (shouldFetchTemplates) {
      dispatch(getReportTemplateSearchResults());
      if (isGenerativeAiEnabled) {
        if (isUngatedToUseChirpEndpoints) {
          dispatch(getChirpAiSearchResults(input, templatesByKey));
        } else {
          dispatch(getAiSearchResults(input, templatesByKey));
        }
      }
    }
  }, [dispatch, filters, history, isGenerativeAiEnabled, reportId, templatesByKey, isUngatedToUseChirpEndpoints]);
  const updateAndRecordSearch = useCallback(input => {
    updateSearch(input);
    if (input) {
      recordAndTrackSearch(input);
    }
  }, [updateSearch]);
  const debouncedUpdateAndRecordSearch = useCallback(input => {
    debounceSearch(input, updateSearch);
    if (input) {
      debounceRecordAndTrackSearch(input, recordAndTrackSearch);
    }
  }, [updateSearch]);
  return {
    updateAndRecordSearch,
    debouncedUpdateAndRecordSearch
  };
};
export default useUpdateSearch;